import { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import useInterval from './useInterval';

const minute = 60;
const hour = 60 * 60;
const day = hour * 24;

const useCountdown = (expireTime, { disabled = false, onExpire, showHour = true } = {}) => {
  const t = useTranslate();
  const isExpired = () => expireTime * 1000 < Date.now();

  const formatCountDown = () => {
    const current = Math.round(new Date().getTime() / 1000);
    let diff = expireTime - current;
    if (diff <= 0) return '00:00:00';

    const days = Math.floor(diff / day);
    diff -= days * day;
    const hours = Math.floor(diff / hour);
    diff -= hours * hour;
    const minutes = Math.floor(diff / minute);
    const seconds = diff - minutes * minute;

    if (days === 0 && hours === 0 && minutes === 0 && seconds === 0 && expireTime) {
      return t('common.text.expired');
    }

    if (days === 0) {
      let timeFormat = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      if (hours !== 0 || showHour) {
        timeFormat = `${hours < 10 ? '0' : ''}${hours}:${timeFormat}`;
      }
      return timeFormat;
    }
    return t('common.text.day', {
      day: days,
    });
  };

  const [expired, setExpired] = useState(() => isExpired());
  const [time, setTime] = useState(() => formatCountDown());

  useEffect(() => {
    setExpired(false);
    // eslint-disable-next-line
  }, [expireTime]);

  useInterval(() => {
    if (expired || disabled) {
      return;
    }

    if (isExpired()) {
      setExpired(true);
      onExpire?.();
      return;
    }

    setTime(formatCountDown());
  }, 1000);

  return {
    time,
    expired,
  };
};

export default useCountdown;
